<dx-box
    #mainView
    *ngIf="!!dashboardItems?.length"
    width="100%"
    height="100%"
    direction="vertical"
    (onContentReady)="computeTileSize()"
>
    <dxi-item [ratio]="1">
        <dx-box [width]="boxWidth" [height]="boxHeight">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <as-split
                        *ngIf="dashboardItems?.length > 1; else singleWidget"
                        #rootSplit
                        direction="vertical"
                        gutterSize="5"
                        [disabled]="!autoFitView"
                        [useTransition]="true"
                        (dragEnd)="updateHeightRatio($event)"
                    >
                        <as-split-area [size]="dashboardItems[0].heightRatio">
                            <as-split
                                #topSplit
                                gutterSize="5"
                                [disabled]="!autoFitView"
                                [direction]="direction"
                                [useTransition]="true"
                                (dragEnd)="updateWidthRatio($event, 0, 1, topSplit)"
                            >
                                <as-split-area
                                    [minSize]="
                                        direction === 'horizontal'
                                            ? dashboardItems[0].calcMinWidthRatio
                                            : dashboardItems[0].calcMinHeightRatio
                                    "
                                    [size]="
                                        direction === 'horizontal'
                                            ? dashboardItems[0].widthRatio
                                            : dashboardItems[0].heightRatio
                                    "
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="widgetTemplate"
                                        [ngTemplateOutletContext]="{ data: dashboardItems[0] }"
                                    ></ng-container>
                                </as-split-area>
                                <as-split-area
                                    [minSize]="
                                        direction === 'horizontal'
                                            ? dashboardItems[1].calcMinWidthRatio
                                            : dashboardItems[1].calcMinHeightRatio
                                    "
                                    [size]="
                                        direction === 'horizontal'
                                            ? dashboardItems[1].widthRatio
                                            : dashboardItems[1].heightRatio
                                    "
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="widgetTemplate"
                                        [ngTemplateOutletContext]="{ data: dashboardItems[1] }"
                                    ></ng-container>
                                </as-split-area>
                                <as-split-area
                                    *ngIf="dashboardItems.length > 2 && viewMode === 'Scroll'"
                                    [minSize]="
                                        direction === 'horizontal'
                                            ? dashboardItems[2].calcMinWidthRatio
                                            : dashboardItems[2].calcMinHeightRatio
                                    "
                                    [size]="
                                        direction === 'horizontal'
                                            ? dashboardItems[2].widthRatio
                                            : dashboardItems[2].heightRatio
                                    "
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="widgetTemplate"
                                        [ngTemplateOutletContext]="{ data: dashboardItems[2] }"
                                    ></ng-container>
                                </as-split-area>
                                <as-split-area
                                    *ngIf="dashboardItems.length > 3 && viewMode === 'Scroll'"
                                    [minSize]="
                                        direction === 'horizontal'
                                            ? dashboardItems[3].calcMinWidthRatio
                                            : dashboardItems[3].calcMinHeightRatio
                                    "
                                    [size]="
                                        direction === 'horizontal'
                                            ? dashboardItems[3].widthRatio
                                            : dashboardItems[3].heightRatio
                                    "
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="widgetTemplate"
                                        [ngTemplateOutletContext]="{ data: dashboardItems[3] }"
                                    ></ng-container>
                                </as-split-area>
                            </as-split>
                        </as-split-area>
                        <as-split-area
                            [size]="dashboardItems[2].heightRatio"
                            *ngIf="dashboardItems.length > 2 && viewMode !== 'Scroll'"
                        >
                            <as-split
                                #bottomSplit
                                direction="horizontal"
                                gutterSize="5"
                                [disabled]="!autoFitView"
                                [useTransition]="true"
                                (dragEnd)="updateWidthRatio($event, 2, 3, bottomSplit)"
                            >
                                <as-split-area
                                    *ngIf="dashboardItems.length > 2 && viewMode !== 'Scroll'"
                                    [minSize]="dashboardItems[2].calcMinWidthRatio"
                                    [size]="dashboardItems[2].widthRatio"
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="widgetTemplate"
                                        [ngTemplateOutletContext]="{ data: dashboardItems[2] }"
                                    ></ng-container>
                                </as-split-area>
                                <as-split-area
                                    *ngIf="dashboardItems.length > 3 && viewMode !== 'Scroll'"
                                    [minSize]="dashboardItems[3].calcMinWidthRatio"
                                    [size]="dashboardItems[3].widthRatio"
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="widgetTemplate"
                                        [ngTemplateOutletContext]="{ data: dashboardItems[3] }"
                                    ></ng-container>
                                </as-split-area>
                            </as-split>
                        </as-split-area>
                    </as-split>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<ng-template #singleWidget>
    <ng-container
        [ngTemplateOutlet]="widgetTemplate"
        [ngTemplateOutletContext]="{ data: dashboardItems[0] }"
    ></ng-container>
</ng-template>

<ng-template #widgetTemplate let-tile="data">
    <div id="tile-container-{{ tile.id || '' }}-{{ tile.widgetId || '' }}" class="cc-full-size">
        <dx-box
            *ngIf="!!tile"
            direction="col"
            class="dashboard-tile"
            width="100%"
            height="100%"
            [attr.id]="'tile-content-' + (tile.id || '') + '-' + (tile.widgetId || '')"
            (onContentReady)="onTileReady(tile)"
            [ngClass]="{
                'bordered-dashboard-tile': showTitle,
                'dx-theme-border-color': !editMode,
                'dx-theme-accent-as-border-color': editMode,
                'cc-white-background': !tile?.isFullScreen,
                'dashboard-fullscreen cc-grey-background': tile?.isFullScreen
            }"
        >
            <dxi-item baseSize="auto" [visible]="showTitle && !editMode && !!tile.title">
                <div *dxTemplate class="cc-white-background dx-theme-border-color">
                    <h3 class="tile-header page-header">
                        <span *ngIf="!!tile?.title">
                            {{ tile.title }}
                            <sup *ngIf="!!tile?.helpLink" class="help-icon">
                                <a [href]="tile?.helpLink" target="_blank" class="fas fa-question-circle"></a>
                            </sup>
                        </span>
                        <span *ngIf="!!tile?.error && editMode" class="tile-error cc-text-required">
                            {{ tile?.error }}
                        </span>
                        <ng-container
                            [ngTemplateOutlet]="widgetIcons"
                            [ngTemplateOutletContext]="{ data: tile }"
                        ></ng-container>
                    </h3>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1" [visible]="editMode">
                <div *dxTemplate class="cc-white-background dx-theme-accent-as-border-color">
                    <h3 class="tile-header page-header tile-header-center">
                        <ng-container
                            [ngTemplateOutlet]="widgetSelector"
                            [ngTemplateOutletContext]="{ data: tile }"
                        ></ng-container>
                    </h3>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1" [visible]="!editMode">
                <div
                    *dxTemplate
                    [attr.id]="'widget-' + (tile.id || '') + '-' + (tile.widgetId || '')"
                    class="cc-white-background tile-body"
                >
                    <ng-template
                        *ngIf="!!tile.widgetId"
                        appDynamicDashboardTemplate
                        [editMode]="editMode"
                        [dashboardItem]="tile"
                        [widgetId]="tile.widgetId"
                    ></ng-template>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</ng-template>

<ng-template #widgetIcons let-tile="data">
    <div class="tile-icons">
        <span
            *ngIf="!!tile.widgetId && tile.widgetChanged"
            class="tile-icon dx-theme-border-color fas fa-undo"
            title="Revert Changes"
            (click)="onRevertWidgetChange(tile)"
        ></span>
        <span
            *ngIf="!!tile.widgetId && tile.widgetChanged"
            class="tile-icon dx-theme-border-color fas fa-save"
            title="Save Changes"
            (click)="onWidgetChange.emit(true)"
        ></span>
        <span
            *ngIf="false"
            [attr.id]="'tile-icon-' + tile.id"
            class="tile-icon dx-theme-border-color fas fa-cog"
            title="Change Widget Quickly"
            (click)="tile.isConfigVisible = true"
        >
            <dx-popover
                [target]="'#tile-icon-' + tile.id"
                [showTitle]="false"
                [closeOnOutsideClick]="true"
                [(visible)]="tile.isConfigVisible"
            >
                <dxo-position>
                    <dxo-at x="left" y="center"></dxo-at>
                    <dxo-my x="right" y="center"></dxo-my>
                    <dxo-collision x="none" y="none"></dxo-collision>
                </dxo-position>
                <div *dxTemplate="let data of 'content'">
                    <ng-container
                        [ngTemplateOutlet]="widgetSelector"
                        [ngTemplateOutletContext]="{ data: tile }"
                    ></ng-container>
                </div>
            </dx-popover>
        </span>
        <span
            *ngIf="!!tile.widgetId && !tile.hideFullScreen"
            class="tile-icon dx-theme-border-color fas"
            title="Toggle Fullscreen"
            [ngClass]="{ 'fa-expand-arrows-alt': !tile.isFullScreen, 'fa-compress-arrows-alt': tile.isFullScreen }"
            (click)="toggleFullScreen(tile)"
        ></span>
    </div>
</ng-template>

<ng-template #widgetSelector let-tile="data">
    <div class="widget-selector">
        <ng-container *ngIf="!hasGroupedWidgets">
            <dx-select-box
                displayExpr="name"
                valueExpr="id"
                placeholder="Select a Widget"
                width="100%"
                validationMessageMode="always"
                [dataSource]="dashboardWidgets"
                [value]="tile?.widgetId"
                (onSelectionChanged)="onDashboardWidgetChange($event, tile)"
            >
                <div *dxTemplate="let data of 'item'">
                    <span [ngClass]="{ 'tree-view-group-node': !data.id, 'tree-view-node-item': !!data.id }">
                        {{ data.name }}
                    </span>
                </div>
                <dx-validator (onInitialized)="onValidatorInit($event, tile)">
                    <dxi-validation-rule type="required" message="Widget is required"></dxi-validation-rule>
                </dx-validator>
            </dx-select-box>
        </ng-container>
        <ng-container *ngIf="hasGroupedWidgets">
            <dx-drop-down-box
                #dropDownBox
                width="100%"
                valueExpr="id"
                displayExpr="name"
                placeholder="Select a Widget"
                validationMessageMode="always"
                [showClearButton]="false"
                [elementAttr]="{ tile: tile }"
                [value]="tile.widgetId"
                [dataSource]="dashboardWidgets"
            >
                <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                        keyExpr="id"
                        displayExpr="name"
                        selectionMode="single"
                        showCheckBoxesMode="none"
                        [selectNodesRecursive]="false"
                        [selectByClick]="false"
                        [activeStateEnabled]="false"
                        [focusStateEnabled]="false"
                        [dataSource]="groupedDashboardWidgets"
                        (onItemClick)="onDashboardWidgetChange($event, tile)"
                    >
                        <div *dxTemplate="let data of 'item'">
                            <span [ngClass]="{ 'tree-view-group-node': !data.id, 'tree-view-node-item': !!data.id }">
                                {{ data.name }}
                            </span>
                        </div>
                    </dx-tree-view>
                </div>
                <dx-validator (onInitialized)="onValidatorInit($event, tile)">
                    <dxi-validation-rule type="required" message="Widget is required"></dxi-validation-rule>
                </dx-validator>
            </dx-drop-down-box>
        </ng-container>
    </div>
</ng-template>
